import React from "react";
import Context from "../../../../Context";
import Blocker from "../../../Misc/Blocker";
import timesheetRefactorInData from "../../Timesheet/timesheetRefactorInData";
import TimesheetTable from "../../Timesheet/TimesheetTable";
export default class WorkdocTimesheet extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pending: false,
      datesData: {},
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let originalDatesData = await this.context.api.qa("/timesheet/date", {
      document: this.props.id,
    });

    let datesData = timesheetRefactorInData(originalDatesData);
    this.setState({ pending: false, datesData });
  };
  render() {
    const { datesData, pending } = this.state;
    const document = this.props.document || {};
    return (
      <>
        <Blocker on={pending} hAuto>
          <h5>{document.label}</h5>
          <div className="mb-4">
            {document.description && (
              <div>
                Комментарий:{" "}
                <span className="text-muted">{document.description}</span>
              </div>
            )}
          </div>
          <TimesheetTable datesData={datesData} readOnly={true} />
        </Blocker>
      </>
    );
  }
}
